// Author Lin
// Date 2021-08-13 17:47:46

import * as model from "@/model/sithMes/inventory/SithMesInventoryChangeMaterialProjectModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryChangeMaterialProject(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_INVENTORY_URL + '/sithMesInventoryChangeMaterialProject/workflow/complete-feedback',
        processDefinitionKey: "inventory_change_material_project",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
